import { Home, Zap, Server, Bot, ExternalLink, LogOut } from 'lucide-react';
import { useAuth } from '../auth';
import { SidebarNavItem } from './SidebarNavItem';

const navItems = [
  { to: '/', icon: Home, label: 'Home', end: true },
  { to: '/skills', icon: Zap, label: 'Skills' },
  { to: '/mcps', icon: Server, label: 'MCP Servers' },
  { to: '/agents', icon: Bot, label: 'Agents' },
];

export function Sidebar() {
  const { user, logout } = useAuth();

  const displayName = user?.name || 'User';
  const email = user?.email || '';
  const initials = displayName
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <aside className="fixed inset-y-0 left-0 z-30 flex w-60 flex-col border-r border-sidebar-border bg-sidebar">
      {/* Logo */}
      <div className="flex h-16 items-center gap-2.5 border-b border-sidebar-border px-5">
        <img src="/pixacore-logo.png" alt="Pixacore" className="h-8 w-8 rounded-lg" />
        <div>
          <h1
            className="text-sm font-bold text-sidebar-accent-foreground flex items-center gap-px"
            style={{ fontFamily: 'Montserrat, Inter, sans-serif', letterSpacing: '0.06em' }}
          >
            <span>C</span>
            <span className="text-primary">O</span>
            <span>RETEX</span>
          </h1>
          <p
            className="text-[10px] text-sidebar-muted tracking-wide"
            style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
          >
            by Pixacore
          </p>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-1 overflow-y-auto px-3 py-4">
        <div className="pb-1 px-3">
          <p className="text-[10px] font-mono uppercase tracking-widest text-sidebar-muted">
            Marketplace
          </p>
        </div>

        {navItems.map((item) => (
          <SidebarNavItem key={item.to} {...item} />
        ))}

        <div className="pt-3 pb-1 px-3">
          <p className="text-[10px] font-mono uppercase tracking-widest text-sidebar-muted">
            Coretex
          </p>
        </div>

        <a
          href="https://coretex.pixacore.com"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 rounded-md px-3 py-2 text-sm text-sidebar-foreground hover:bg-sidebar-accent/50 hover:text-sidebar-accent-foreground transition-colors group"
        >
          <ExternalLink className="h-4 w-4 shrink-0" />
          <span className="truncate flex-1">Coretex Hub</span>
          <ExternalLink className="h-3 w-3 shrink-0 opacity-0 group-hover:opacity-100 text-sidebar-muted transition-opacity" />
        </a>
      </nav>

      {/* User */}
      <div className="border-t border-sidebar-border px-3 py-3">
        <div className="flex items-center gap-3 px-2 py-2">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sidebar-accent text-xs font-medium text-sidebar-accent-foreground">
            {initials}
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate text-xs font-medium text-sidebar-accent-foreground">
              {displayName}
            </p>
            <p className="truncate text-[10px] text-sidebar-muted">{email}</p>
          </div>
          <button
            onClick={logout}
            className="shrink-0 text-sidebar-muted hover:text-destructive transition-colors"
            title="Sign out"
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>
    </aside>
  );
}
